import { passosReframing } from '../../../mocks/worksheet-ressignificacao';

export default function PassosReframing() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Os 6 Passos do Reframing
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Siga este processo para transformar qualquer situação limitante em uma perspectiva empoderadora
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {passosReframing.map((passo) => (
            <div
              key={passo.numero}
              className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100"
            >
              <div className={`w-14 h-14 bg-gradient-to-br ${passo.cor} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`${passo.icone} text-white text-2xl`}></i>
              </div>

              <div className="flex items-center gap-3 mb-3">
                <span className={`text-sm font-bold bg-gradient-to-r ${passo.cor} bg-clip-text text-transparent`}>
                  PASSO {passo.numero}
                </span>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {passo.titulo}
              </h3>

              <p className="text-gray-600 leading-relaxed">
                {passo.descricao}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-purple-50 via-pink-50 to-rose-50 p-8 rounded-2xl">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-line text-white text-2xl"></i>
            </div>
            <div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Dica Importante</h4>
              <p className="text-gray-700 leading-relaxed">
                Não existe uma única resposta "certa". O objetivo é expandir suas possibilidades de interpretação. 
                Quanto mais perspectivas você conseguir ver, mais liberdade terá para escolher como se sentir e agir.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}